export default __webpack_public_path__ + "static/media/roomBg.c4749961.jpg";